import type { FC } from 'react';
import { useEffect } from 'react';
import { DevTool } from '@hookform/devtools';
import { createRoot } from 'react-dom/client';

import './FormDevTool.scss';

interface Props {
    control: any;
}

/**
 * Form Dev Tool to debug forms. Library tracks "open" status in the localStorage, so if a
 * developer does not want to use dev tool, he will just see tiny icon to open it (on bottom right).
 */
export const FormDevTool: FC<Props> = ({ control }) => {
    useEffect(() => {
        /**
         * We need to mount the dev tool component to the body, so its displayed correctly.
         * Otherwise, it displays fixed to the parent.
         *
         * We also need to wrap it with custom styles to increase z-index,
         * otherwise it breaks in focus pages.
         */
        const elemDiv = document.createElement('div');
        elemDiv.className = 'form-dev-tool';
        document.body.append(elemDiv);
        const root = createRoot(elemDiv);

        root.render(<DevTool control={control} placement="bottom-right" />);

        // cleanup on un-mount
        return () => {
            setTimeout(() => {
                root.unmount();
                elemDiv.remove();
            });
        };
    }, [control]);

    return null;
};
